import { type MouseEvent, useCallback, useMemo, useState } from 'react';

export type UsePopoverReturn = {
  open: boolean;
  anchorEl: HTMLElement | null;
  onOpen: (event: MouseEvent<HTMLElement>) => void;
  onClose: () => void;
};

export function usePopover(): UsePopoverReturn {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const onOpen = useCallback((event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  }, []);

  const onClose = useCallback(() => setAnchorEl(null), []);

  return useMemo(
    () => ({ open: anchorEl !== null, anchorEl, onOpen, onClose }),
    [anchorEl, onOpen, onClose],
  );
}
